<template>
  <v-container 
    id="removedor-georreferenciado-historico" 
    tag="section"
    fluid
  >
    <v-row align="center">
      <v-col cols="12">
        <remover-georreferenciado-data-table
        :items="expurgos"
        :loading="loading"
        @rechargeTable="getExpurgos()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GeorreferenciadoService from "@/services/RemoverGeorreferenciadoService"
import tourMixins from '@/mixins/tourMixins';
import pusherMixins from "@/mixins/pusherMixins";

export default {
  mixins: [pusherMixins, tourMixins],

  components: {
    removerGeorreferenciadoDataTable: () => import("@/components/removedorGeorreferenciado/RemoverGeorreferenciadoDataTable.vue"),
  },

  mounted() {
    this.getExpurgos();
    this.subscribe();
  },

  data () {
    return {
      expurgos: [],
      loading: false,
      arrTour: [
        {
          element: '#btn-novo-expurgo',
          intro: 'Clicando neste botão você poderá criar novos Expurgos de Georreferenciado.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: "#removedor-georreferenciado-historico-search",
          intro: "Neste campo você poderá pesquisar por Expurgos já existentes.",
          scrollTo: "tooltip",
          position: 'bottom'
        },
        {
          element: '#action-excluir-expurgo',
          intro: 'Clicando neste ícone você poderá excluir Expurgos de Georreferenciado.',
          scrollTo: "tooltip",
          position: 'left'
        },   
      ]
    }
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('reload-pag-remover-georreferenciado', () => {
        this.getExpurgos();
      });
    },

    getExpurgos(){
      this.loading = true;
      GeorreferenciadoService.getExpurgos()
      .then(resp => {
        this.expurgos = resp.data.expurgos
        
      })
      .catch(err => {
        console.error(err);
        this.$toast.error('Erro ao recuperar expurgos.', '', { position:'topRight' });
      })
      .finally(() => { this.loading = false , this.iniciarTourPagina();});
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.expurgos.length ? this.arrTour : this.arrTour.splice(0,2);
      this.iniciarTour(arrTourFormatted);
    }
  },

}
</script>